import { render, staticRenderFns } from "./locadorPrestadorReportModel.vue?vue&type=template&id=32aff818&scoped=true"
import script from "./locadorPrestadorReportModel.vue?vue&type=script&lang=js"
export * from "./locadorPrestadorReportModel.vue?vue&type=script&lang=js"
import style0 from "./locadorPrestadorReportModel.vue?vue&type=style&index=0&id=32aff818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32aff818",
  null
  
)

export default component.exports